import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'store/RootState'
import { initialState } from './slice'

const selectDomain = (state: RootState) => state.auth || initialState

export const selectAuth = createSelector([selectDomain], auth => auth)
